<script setup lang="ts">
import SearchableModel from "@/components/searchable-model/SearchableModel.vue";
import { formatMoney } from "@/utils/money";
import dayjs from "dayjs";
import DepositStatus from "@/components/payment/DepositStatus.vue";

const props = defineProps({
  baseFilters: {
    type: Object,
    default: () => ({})
  },
  availableFilters: {
    type: Array,
    default: () => []
  },
})
</script>

<template>
  <SearchableModel
    model-name="Deposit"
    with-search
    load-on-start
    :search-placeholder="$t('Search by name, email, phone number or badge number')"
    :base-filters="props.baseFilters"
    :available-filters="props.availableFilters"
    enable-container
    push-state
    v-slot="{ models }"
  >
    <div class="tw:max-w-[1400px] tw:mx-auto">
      <table v-if="models" class="table table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t('Amount') }}</th>
            <th>{{ $t('Registration') }}</th>
            <th>{{ $t('Status') }}</th>
            <th>{{ $t('Created at') }}</th>
            <th>{{ $t('Capture before') }}</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="deposit in models">
          <td>
            # {{ deposit.id }}
          </td>
          <td>
            {{ formatMoney(deposit.amount) }}
          </td>
          <td>
            <template v-if="deposit.registration">
              <a :href="deposit.registration.links.show">
                {{ deposit.registration.firstname }} {{ deposit.registration.lastname }}
              </a>
            </template>
            <template v-else>
              N/A
            </template>
          </td>
          <td>
            <DepositStatus :status="deposit.status" />
          </td>
          <td>
            {{ dayjs(deposit.created_at).format('lll') }}
          </td>
          <td>
            {{ deposit.capture_before ? dayjs(deposit.capture_before).format('lll') : 'N/A' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </SearchableModel>
</template>

<style scoped>

</style>
